import Terms from '../../../components/public/giftCard/terms/terms';

const GiftCardTerms = (): JSX.Element => {
  return <Terms />;
};
export default GiftCardTerms;
